<app-page [kontentCodename]="'introduction_to_classical_education__page_'"></app-page>
